import splitToWords from "./splitToWords";
/*
  This function just gives us a count of cells (columns or rows).
 */

var lengthOf = function lengthOf(value) {
  var _splitToWords;

  return value ? (_splitToWords = splitToWords(value)) === null || _splitToWords === void 0 ? void 0 : _splitToWords.length : undefined;
};

export default lengthOf;